// import { Field, FieldProps } from "components/Vant"
import React, { ReactNode } from "react"
import { ConfigProvider, Field, Icon } from "react-vant"
import { FieldProps } from "react-vant/es/field"
import { cls } from "reactutils"

export type MallFieldProps = FieldProps & {
  className?: string
  rightIcon?: boolean
  customRightIcon?: string | ReactNode
  shortBorderBottom?: boolean
  withBorder?: boolean
  disabled?: boolean
}

const MallField = React.forwardRef(function MallField(
  {
    className,
    inputAlign = "right",
    rightIcon = false,
    customRightIcon,
    shortBorderBottom,
    withBorder = true,
    disabled = false,
    ...others
  }: MallFieldProps,
  ref: any,
) {
  const themeVars = {
    "--rv-cell-vertical-padding": "15px",
    "--rv-field-label-color": "#666",
    "--rv-field-input-text-color": "#000",
    "--rv-cell-value-color": "#000",
    "--rv-field-right-icon-color": "#bbbbbb",
  }

  return (
    <ConfigProvider themeVars={themeVars}>
      <div
        className={cls(
          "field",
          className,
          !shortBorderBottom && withBorder && "full-border",
          shortBorderBottom && "short-border",
        )}
      >
        <Field
          ref={ref}
          inputAlign={inputAlign}
          errorMessageAlign="right"
          disabled={disabled}
          rightIcon={
            customRightIcon ||
            (rightIcon && (
              <div className="arrowIcon">
                <Icon name="arrow" />
              </div>
            ))
          }
          required={false}
          {...others}
        />
        <style jsx>{`
          .field {
            cursor: pointer;
            position: relative;
          }
          .field.full-border::after {
            content: " ";
            display: block;
            margin: 0 16px;
            border-bottom: 1px solid #eeeeee;
          }
          .field.short-border::after {
            position: absolute;
            bottom: 0;
            content: " ";
            display: block;
            margin: 0 16px;
            bottom: 1px;
            width: calc(100% - 16px);
            background: #eeeeee;
            left: 0px;
            height: 1px;
          }
          .field :global(.rv-field__label) {
            font-size: 14px;
            font-weight: 400;
          }

          .field :global(.rv-field__control) {
            font-size: 14px;
            font-weight: 400;
          }

          .field :global(.rv-field__error-message) {
            line-height: 12px;
          }

          .arrowIcon {
            display: flex;
            align-items: center;
          }

          .arrowIcon :global(svg) {
            width: 12px;
            height: 12px;
          }

          .arrowIcon :global(svg) :global(path) {
            fill: #bbb;
          }
        `}</style>
      </div>
    </ConfigProvider>
  )
})

export default MallField
